import { Pipe, PipeTransform } from '@angular/core';
import { UiTblSubSO } from '../shared/misc-classes';
import { UiTblSubSOBrkPSLevel } from '../shared/ui-classes';

@Pipe({
  name: 'subSOFilter'
})
export class SubEqupUIPipePipe implements PipeTransform {

  transform(items: Array<UiTblSubSOBrkPSLevel>, search: string): any {
    if(items ==null || search == null || search == ''){
      return items;
    }
    return items.filter((_obj:UiTblSubSOBrkPSLevel) => {
      return _obj.searchText(search);
    })
  }

}
